/**
 * Quantity Buttons Module
 *
 * Adds plus/minus buttons to WooCommerce quantity inputs
 * for better UX on product and cart pages.
 *
 * @package Safari_Theme
 */

const NAMESPACE = "safari";

/**
 * Initialize quantity buttons functionality
 */
export function initQuantityButtons() {
  if (!isProductOrCartPage()) return;
  if (!document.querySelector("input.qty")) return;

  addQuantityButtons();
  handleQuantityClicks();

  console.log("Quantity buttons initialized");
}

/**
 * Reinitialize buttons after AJAX updates
 */
export function reinitializeQuantityButtons() {
  // Remove existing wrappers to prevent duplicates
  document.querySelectorAll("input.qty").forEach((input) => {
    const wrapper = input.parentElement;
    if (
      wrapper &&
      wrapper.classList.contains(`${NAMESPACE}-quantity-wrapper`)
    ) {
      wrapper.replaceWith(input);
    }
  });

  addQuantityButtons();
}

/**
 * Add plus/minus buttons
 */
function addQuantityButtons() {
  const quantityInputs = document.querySelectorAll("input.qty");

  quantityInputs.forEach((input) => {
    if (input.parentElement.classList.contains(`${NAMESPACE}-quantity-wrapper`))
      return;

    const wrapper = document.createElement("div");
    wrapper.className = `${NAMESPACE}-quantity-wrapper`;
    wrapper.setAttribute("role", "spinbutton");
    wrapper.setAttribute("aria-valuemin", input.getAttribute("min") || 1);
    wrapper.setAttribute("aria-valuemax", input.getAttribute("max") || 999);
    wrapper.setAttribute("aria-valuenow", input.value || 1);

    const minusBtn = document.createElement("button");
    minusBtn.type = "button";
    minusBtn.className = `${NAMESPACE}-qty-btn minus`;
    minusBtn.innerHTML = "-";
    minusBtn.setAttribute("aria-label", "Decrease quantity");

    const plusBtn = document.createElement("button");
    plusBtn.type = "button";
    plusBtn.className = `${NAMESPACE}-qty-btn plus`;
    plusBtn.innerHTML = "+";
    plusBtn.setAttribute("aria-label", "Increase quantity");

    // Wrap input and add buttons
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(minusBtn);
    wrapper.appendChild(input);
    wrapper.appendChild(plusBtn);
  });
}

/**
 * Handle plus/minus clicks
 */
function handleQuantityClicks() {
  const container = document.querySelector(".woocommerce") || document.body;

  container.addEventListener("click", (e) => {
    if (!e.target.classList.contains(`${NAMESPACE}-qty-btn`)) return;

    e.preventDefault();

    const btn = e.target;
    const input = btn.parentElement.querySelector("input.qty");
    if (!input) return;

    const min = parseInt(input.getAttribute("min")) || 1;
    const max = parseInt(input.getAttribute("max")) || 999;
    let value = parseInt(input.value) || min;

    if (btn.classList.contains("plus") && value < max) value++;
    if (btn.classList.contains("minus") && value > min) value--;

    if (value !== parseInt(input.value)) {
      input.value = value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.parentElement.setAttribute("aria-valuenow", value);

      if (isCartPage()) updateCartQuantity(input);
    }
  });
}

/**
 * Update cart quantity on cart page
 */
function updateCartQuantity(input) {
  const updateBtn = document.querySelector('[name="update_cart"]');
  if (!updateBtn) return;

  updateBtn.removeAttribute("disabled");
  updateBtn.setAttribute("aria-disabled", "false");

  clearTimeout(window.cartUpdateTimeout);
  window.cartUpdateTimeout = setTimeout(() => {
    updateBtn.click();
  }, 800);
}

/**
 * Page checks
 */
function isProductOrCartPage() {
  return (
    document.body.classList.contains("single-product") ||
    document.body.classList.contains("woocommerce-cart")
  );
}

function isCartPage() {
  return document.body.classList.contains("woocommerce-cart");
}

function isProductPage() {
  return document.body.classList.contains("single-product");
}
